import { render, staticRenderFns } from "./historyOrder.vue?vue&type=template&id=dc80a95c&"
import script from "./historyOrder.vue?vue&type=script&lang=js&"
export * from "./historyOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports